import { createAction, props } from '@ngrx/store';


export const loadOrgDonations = createAction(
  '[Dashboard] Load OrgDonations',
  props<any>()
);

export const loadOrgDonationsSuccess = createAction(
  '[Dashboard] Load OrgDonations Success',
  props<{ data: any }>()
);

export const loadOrgDonationsFailure = createAction(
  '[Dashboard]  Load OrgDonations Failure',
  props<{ error: any }>()
);

export const loadCampaignReport = createAction(
  '[Dashboard] Load campaignReport',
  props<any>()
);

export const loadCampaignReportSuccess = createAction(
  '[Dashboard] Load campaignReport Success',
  props<{ data: any }>()
);

export const loadCampaignReportFailure = createAction(
  '[Dashboard]  Load campaignReport Failure',
  props<{ error: any }>()
);

export const loadOrgUser = createAction(
  '[Dashboard] Load loadOrgUser',
  props<any>()
);

export const loadOrgUserSuccess = createAction(
  '[Dashboard] Load loadOrgUser Success',
  props<{ data: any }>()
);

export const loadOrgUserFailure = createAction(
  '[Dashboard]  Load loadOrgUser Failure',
  props<{ error: any }>()
);

export const switchOrgUser = createAction(
  '[Dashboard] Load switchOrgUser',
  props<any>()
);

export const switchOrgUserSuccess = createAction(
  '[Dashboard] Load switchOrgUser Success',
  props<{ data: any }>()
);

export const switchOrgUserFailure = createAction(
  '[Dashboard]  Load switchOrgUser Failure',
  props<{ error: any }>()
);

export const resetDashboard = createAction(
  '[Dashboard]  Reset Dashboard',
  props<{ error: any }>()
);

export const loadUpcomingReminders = createAction(
  '[Dashboard] Load UpcomingReminders',
  props<any>()
);

export const loadUpcomingRemindersSuccess = createAction(
  '[Dashboard] Load UpcomingReminders Success',
  props<{ data: any }>()
);

export const loadUpcomingRemindersFailure = createAction(
  '[Dashboard]  Load UpcomingReminders Failure',
  props<{ error: any }>()
);

export const cancelUpcomingReminder = createAction(
  '[Dashboard] Cancel UpcomingReminder',
  props<any>()
);

export const cancelUpcomingReminderSuccess = createAction(
  '[Dashboard] Cancel UpcomingReminder Success',
  props<{ data: any }>()
);

export const cancelUpcomingReminderFailure = createAction(
  '[Dashboard]  Cancel UpcomingReminder Failure',
  props<{ error: any }>()
);